/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { TextureLoader } from 'three';
import { Text2DFontMSDF } from './Text2DFontMSDF';
/**
 * load a font from url
 */
export class Text2DFontLoader {
    static async getFont(url, urlBase = '') {
        const response = await fetch(url);
        const fontDesc = await response.json();
        const loader = new TextureLoader();
        // TODO : delete this after implementing multipages
        if (fontDesc.common.pages > 1) {
            // tslint:disable-next-line:no-console
            console.log('Text2D multipages still not supported');
        }
        const fontTextures = fontDesc.pages.map((path) => loader.load(urlBase + path));
        const font = new Text2DFontMSDF(fontTextures, fontDesc.common.scaleW, fontDesc.common.lineHeight, fontDesc.chars);
        return font;
    }
}
//# sourceMappingURL=Text2DFontLoader.js.map